import * as z from "zod";
import { attachmentSchema, dateSchema } from "./schemasComplex";
import { zRequiredString } from "./schemaUtils";

export const schemaFormAudit = z.object({
  title: zRequiredString("Veuillez dÃ©finir un titre"),
  description: z.string().optional(),
  site: zRequiredString("Veuillez dÃ©finir un site"),
  audit_type: zRequiredString("Veuillez dÃ©finir un type d'audit"),
  dateAudit: dateSchema,
  accessGivenTo: z.array(z.string()).optional(),
  accessRoleGivenTo: z.array(z.string()).optional(),
  attachedFiles: attachmentSchema,
});
